/**
 * 历史列表服务端分页查询参数（对齐 GET /api/tasks）。
 * @param {{ subAccount?: string, status?: string, startDate?: string, endDate?: string, operatorUserId?: string }} filters
 * @param {{ type: string, page: number, pageSize: number, sourceNav?: string }} paging
 */
export function buildHistoryTasksListQuery(filters = {}, { type, page = 1, pageSize = 20, sourceNav } = {}) {
  const query = {
    type,
    page: Math.max(1, Number(page) || 1),
    pageSize: Math.max(1, Math.min(100, Number(pageSize) || 20)),
    summary: true,
  };
  const keyword = String(filters.subAccount || '').trim();
  if (keyword) {
    query.q = keyword;
  }
  if (filters.startDate) {
    query.createdFrom = String(filters.startDate).trim();
  }
  if (filters.endDate) {
    query.createdTo = String(filters.endDate).trim();
  }
  const status = String(filters.status || '').trim();
  if (status === 'executing') {
    query.statuses = 'executing,processing,pending,waiting,new,running,queued';
  } else if (status === 'success') {
    query.statuses = 'success,succeed,completed';
  } else if (status === 'partial') {
    query.statuses = 'partial,canceled,cancelled';
  } else if (status) {
    query.status = status;
  }
  const nav = String(sourceNav || '').trim();
  if (nav === 'goods' || nav === 'podProductDesign') {
    query.sourceNav = nav;
  }
  const operatorUserId = String(filters.operatorUserId || '').trim();
  if (operatorUserId) {
    query.ownerUserId = operatorUserId;
  }
  return query;
}
